export class Layer {
  title: string;
  opacity: number;
  url: string;
  visible: boolean;
  type?: 'Imagery' | 'MapImage' | 'KML' | 'Feature' = 'MapImage';
  popupTemplate?: any;
  outFields?: any;
  roles?: string[];
}
